import { useState } from "react";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import SectionComments from "./components/SectionComments";
import SectionMedia from "./components/SectionMedia";
import SectionTopics from "./components/SectionTopics";
import SectionCarousel from "./components/SectionCarousel";
import SectionIndex from "./components/SectionIndex";
import SectionUpdates from "./components/SectionUpdates";
import SectionFAQ from "./components/SectionFAQ";
import SectionCards from "./components/SectionCards";
import SectionRanking from "./components/SectionRanking";
import { features } from "@/mocks/home";

export default function Home() {
  const [contactStatus, setContactStatus] = useState<string>("");

  const handleContactSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    if (formData.get("website_alt")?.toString().trim()) {
      setContactStatus("感谢您的留言，我们会尽快回复！");
      form.reset();
      return;
    }
    setContactStatus("感谢您的留言，我们会尽快回复！");
    form.reset();
  };

  return (
    <>
      <Header />

      <main>
        <HeroSection />

        {/* #comments - 观众热评 */}
        <SectionComments />

        {/* #contact - 联系/投稿入口 */}
        <section id="contact" className="py-16 md:py-20 bg-background-50">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
              <p className="mt-3 text-foreground-600 text-sm md:text-base">投稿推荐 · 问题反馈 · 商务合作</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
              <form
                data-readdy-form
                onSubmit={handleContactSubmit}
                className="flex flex-col gap-4"
              >
                <div className="contact-form-field-alt">
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                      您的称呼
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的称呼"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                      电子邮箱
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    留言主题
                  </label>
                  <select
                    name="topic"
                    className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                  >
                    <option value="">请选择主题</option>
                    <option value="投稿">内容投稿推荐</option>
                    <option value="反馈">问题与反馈</option>
                    <option value="合作">商务合作</option>
                    <option value="其他">其他</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    留言内容
                  </label>
                  <textarea
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-3 py-2 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入您的留言内容，不超过500字"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full sm:w-auto self-start px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap"
                >
                  提交留言
                </button>
                {contactStatus && (
                  <p className="text-sm text-secondary-600 font-medium">{contactStatus}</p>
                )}
              </form>
            </div>
          </div>
        </section>

        {/* #media - 热门影片 */}
        <SectionMedia />

        {/* #topics - 热门话题 */}
        <SectionTopics />

        {/* #carousel - 焦点专题 */}
        <SectionCarousel />

        {/* #about - 品牌介绍 */}
        <section id="about" className="py-16 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于51视频</h2>
            <div className="mt-8 text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
              <p>
                51视频诞生于对纯净观影体验的执着追求。在广告泛滥、画质参差不齐的在线视频环境中，我们决心打造一个完全免费、全程无广告、全站蓝光4K超清的高品质视频平台。
              </p>
              <p>
                平台聚合<strong>蓝莓视频</strong>的热门大片、<strong>糖心视频</strong>的高分剧集、<strong>黑桃视频</strong>的经典修复以及<strong>妖精视频</strong>的同步番剧四大核心专区，覆盖电影、电视剧、纪录片、动漫等全品类内容。片库总量突破15,000部，每周更新，让每一次打开都有新发现。
              </p>
              <p>
                我们自建CDN加速网络，全国多节点覆盖，配合智能自适应码率技术，无论您使用PC、手机还是平板，都能享受流畅不缓冲的极致观影体验。51视频，让好内容被更多人看见。
              </p>
            </div>
            <div className="mt-8 flex flex-wrap justify-center gap-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-500">15,000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清片库</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-500">4大专区</div>
                <div className="text-xs text-foreground-500 mt-1">内容矩阵</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-secondary-500">100万+</div>
                <div className="text-xs text-foreground-500 mt-1">月活用户</div>
              </div>
            </div>
          </div>
        </section>

        {/* #index - 主题专区 */}
        <SectionIndex />

        {/* #app - 移动端入口 */}
        <section id="app" className="py-16 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="bg-background-100 rounded-lg p-8 md:p-10 border border-background-200/70 text-center">
              <div className="w-16 h-16 mx-auto rounded-xl bg-primary-500/10 flex items-center justify-center mb-5">
                <i className="ri-smartphone-line text-2xl text-primary-500"></i>
              </div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">移动端观影体验</h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto">
                无需下载APP，手机浏览器打开即可畅享蓝光4K超清画质。支持手势控制音量亮度、画中画播放，通勤路上、睡前时光，随时随地享受高清观影。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#media"
                  className="w-full sm:w-auto px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap"
                >
                  <i className="ri-play-circle-line mr-1.5"></i>立即体验
                </a>
                <span className="text-xs text-foreground-500">支持 iOS Safari / Android Chrome / 所有主流浏览器</span>
              </div>
            </div>
          </div>
        </section>

        {/* #features - 特色优势 */}
        <section id="features" className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">为什么选择51视频</h2>
              <p className="mt-3 text-foreground-600 text-sm md:text-base">三大核心优势，定义极致观影标准</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {features.map((item) => (
                <div
                  key={item.id}
                  className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center"
                >
                  <div className="w-14 h-14 mx-auto rounded-xl bg-primary-500/10 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* #updates - 最新动态 */}
        <SectionUpdates />

        {/* #faq - 常见问题 */}
        <SectionFAQ />

        {/* #cards - 精选推荐 */}
        <SectionCards />

        {/* #ranking - 热播榜单 */}
        <SectionRanking />
      </main>

      <footer id="footer" className="bg-background-900 text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-heading font-bold mb-4">51视频</h3>
              <p className="text-sm text-white/55 leading-relaxed">
                蓝光4K超清视频在线观看平台。汇聚蓝莓视频、糖心视频、黑桃视频、妖精视频四大专区海量资源，完全免费无广告，播放流畅不缓冲。
              </p>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4">内容专区</h3>
              <ul className="flex flex-col gap-2">
                <li><a href="#media" className="text-sm text-white/55 hover:text-primary-400 transition-colors">蓝莓视频</a></li>
                <li><a href="#media" className="text-sm text-white/55 hover:text-primary-400 transition-colors">糖心视频</a></li>
                <li><a href="#media" className="text-sm text-white/55 hover:text-primary-400 transition-colors">黑桃视频</a></li>
                <li><a href="#media" className="text-sm text-white/55 hover:text-primary-400 transition-colors">妖精视频</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4">快速链接</h3>
              <ul className="flex flex-col gap-2">
                <li><a href="#comments" className="text-sm text-white/55 hover:text-primary-400 transition-colors">观众热评</a></li>
                <li><a href="#index" className="text-sm text-white/55 hover:text-primary-400 transition-colors">主题专区</a></li>
                <li><a href="#faq" className="text-sm text-white/55 hover:text-primary-400 transition-colors">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-white/55 hover:text-primary-400 transition-colors">联系我们</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-sm font-semibold mb-4">合作伙伴</h3>
              <p className="text-sm text-white/40">优质内容合作方持续接入中</p>
            </div>
          </div>
          <div className="mt-10 pt-6 border-t border-white/10 text-center">
            <p className="text-xs text-white/40">
              51视频 — 蓝光4K超清无广告不缓冲免费高清在线观看平台。本站所有内容仅供学习交流，请支持正版。
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}